<template>
    <v-app>
        <h1>Компонент недоступен. Недостаточно прав</h1>
    </v-app>
</template>

<script>
export default {
    name: "access-denied"
};
</script>
